import React from "react";
import $ from "jquery";
import CTAMenuLink from "../../../modules/cta_menu_link_module"

const FooterMenu = ({data}) => {
    
    const handleShow = event => {
        //$(".footer-list .menu-list button").removeClass("active-menu")

        if(event.currentTarget.classList.contains("active-menu")){
            event.currentTarget.classList.remove("active-menu")
        } else{
            $(".menu-list-wrap .menu-list button").removeClass("active-menu")
            event.currentTarget.classList.add('active-menu')
        }

    };

    return (

        <div className={`menu-list-wrap menu_count_${data?.length}`}>
            {data?.map((item, index) => {
                return(
                    <div className={`menu-list ${item.title.toLowerCase().replace(/ /g, '_')}`}>
                        <div className="heading-wrap">
                            <h5>{item.title}</h5>
                        </div>
                        {/* <button onClick={handleShow} className="d-md-none">
                            <i className="icon-plus"></i>
                            <i className="icon-minus"></i>
                        </button> */}

                        {item?.footer_links?.length > 0 && 
                        <ul>
                            {item?.footer_links?.map((item, index) => {
                                return(
                                    <li><CTAMenuLink item={item} /> </li>
                                )
                            })}                            
                        </ul>
                        }
                    </div>
                )
            })}
        </div>
    )
}
export default FooterMenu;